'use client';

import { Clock } from 'lucide-react';

interface ComingSoonPanelProps {
  /**
   * The name of the feature/section to display.
   */
  featureName?: string;
}

/**
 * A placeholder panel displayed for features that are not yet available.
 * Used both for navigation guards and direct URL access.
 */
export function ComingSoonPanel({ featureName }: ComingSoonPanelProps) {
  return (
    <div className="flex-1 bg-gray-50 flex items-center justify-center min-h-[400px]">
      <div className="text-center max-w-md px-6">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
          <Clock className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">
          Coming Soon
        </h2>
        {featureName && (
          <p className="text-lg text-gray-600 mb-2">
            {featureName}
          </p>
        )}
        <p className="text-gray-500">
          This feature is currently under development and will be available soon.
        </p>
      </div>
    </div>
  );
}
